import { CircularProgress, MenuItem, Stack } from "@mui/material";
import { useAutoProgress } from "../forms/fields/AutoProgressButton";

export const AutoProgressMenuItem = ({ onClick: propsOnClick, children, startIcon, ...rest }) => {
    const { inProgress, onClick } = useAutoProgress(propsOnClick);

    return (
        <MenuItem disabled={inProgress} onClick={onClick} { ...rest}>
            <Stack direction="row" spacing={1}>
                {inProgress && startIcon ? <CircularProgress color="inherit" size={20}/> : startIcon}
                {children}
            </Stack>
        </MenuItem>
    );
};
